'use client'

import { Button } from '@/components/ui/button'
import { Container } from '@/components/ui/container'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { QuoteSection as QuoteSectionType } from '@/types/cxp-solution-page'
import Image from 'next/image'

interface QuoteSectionProps {
  data?: QuoteSectionType
}

const DEFAULT_QUOTE: QuoteSectionType = {
  quote_text: 'Kịp Tiến Độ, Trọn Chỉn Chu',
  description:
    'CXP cam kết mọi đơn hàng được xử lý linh hoạt dù lớn hay nhỏ, với 100% chất lượng và sự tận tâm của Coolmate.',
  image: '/image/placeholder-quote.jpg',
  cta_button: {
    text: 'Liên hệ CXP by Coolmate',
    ga_tracking_value: 'CXP_quote_cta',
    ga_tracking_label: 'CXP_quote_cta',
  },
}

export function QuoteSection({ data }: QuoteSectionProps) {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form')
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const quote = data || DEFAULT_QUOTE

  if (
    !quote ||
    !quote.quote_text ||
    !quote.description ||
    !quote.image ||
    !quote.cta_button.text
  ) {
    return null
  }

  return (
    <div className='bg-neutral-100 py-20'>
      <Container fluid={true}>
        <div className='flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-16'>
          {/* Left - Image */}
          <div className='relative h-[586px] basis-2/3 overflow-hidden rounded-3xl'>
            <Image
              src={ImageHelper.getImageUrl(quote.image)}
              alt={quote.quote_text}
              fill
              className='object-cover'
              sizes='(max-width: 1024px) 100vw, 1042px'
            />
          </div>

          {/* Right - Content */}
          <div className='flex basis-1/3 flex-col justify-between gap-8'>
            <div className='flex flex-col gap-4'>
              <h2 className='font-formaDjr text-[48px] font-medium italic leading-tight tracking-[-0.96px] text-neutral-900 md:text-[55px] lg:text-[65px]'>
                &ldquo;
                {quote?.quote_text?.includes(',') ? (
                  <>
                    {quote.quote_text.split(',')[0]},
                    <br />
                    <span className='text-[#ff4e00]'>
                      {quote.quote_text.split(',').slice(1).join(',').trim()}
                    </span>
                  </>
                ) : (
                  quote.quote_text
                )}
                &rdquo;
              </h2>
              <p
                className='font-sans text-lg leading-relaxed text-neutral-800 md:text-xl'
                dangerouslySetInnerHTML={{ __html: quote.description }}
              />
            </div>
            <Button
              onClick={scrollToForm}
              className='w-fit rounded-full bg-neutral-900 px-10 py-3 text-base font-medium text-white hover:bg-neutral-800'
              ga-tracking-value={quote.cta_button.ga_tracking_value}
              ga-tracking-label={quote.cta_button.ga_tracking_label}
            >
              <span>{quote.cta_button.text}</span>
              <svg
                width='19'
                height='20'
                viewBox='0 0 19 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='ml-2 h-5 w-5'
              >
                <path
                  d='M0 10H17M17 10L9 2M17 10L9 18'
                  stroke='currentColor'
                  strokeWidth='2'
                />
              </svg>
            </Button>
          </div>
        </div>
      </Container>
    </div>
  )
}
